import { render, staticRenderFns } from "./nott.vue?vue&type=template&id=8e303314&scoped=true"
import script from "./nott.vue?vue&type=script&lang=js"
export * from "./nott.vue?vue&type=script&lang=js"
import style0 from "./nott.vue?vue&type=style&index=0&id=8e303314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e303314",
  null
  
)

export default component.exports